import React, { useState, useEffect } from "react";
import { Card, Image, Skeleton, Row, Col, notification, Typography, Empty } from "antd";
import { ScreenshotDto } from "../../types/devicemanagementtypes";
import { getDeviceScreenshots } from "../../services/devicemanagementservice";

const { Text } = Typography;

interface Props {
    deviceId: string;
    triggerLoad: boolean;
    refreshKey?: number;
}

const DeviceScreenshotsCard: React.FC<Props> = ({ deviceId, triggerLoad, refreshKey }) => {
    const [screenshots, setScreenshots] = useState<ScreenshotDto[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchScreenshots = async () => {
        setLoading(true);
        try {
            const { data } = await getDeviceScreenshots(deviceId);
            setScreenshots(data.screenshots);
        } catch {
            notification.error({
                message: "Error",
                description: "Failed to fetch screenshots",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (triggerLoad) {
            fetchScreenshots();
        }
    }, [triggerLoad, refreshKey]);

    return (
        <Card bordered={false} style={{ padding: 0 }}>
            {loading ? (
                <Row gutter={[8, 8]}>
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Col key={i} xs={24} sm={12} md={8} lg={6} xl={4}>
                            <div
                                style={{
                                    width: "100%",
                                    aspectRatio: "1 / 1",
                                    background: "#f0f0f0",
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Skeleton.Image
                                    style={{ width: "80%", height: "80%" }}
                                    active
                                />
                            </div>
                        </Col>
                    ))}
                </Row>
            ) : screenshots.length > 0 ? (
                <div
                    style={{
                        maxHeight: 500,
                        overflowY: "auto",
                        padding: 4,
                    }}
                >
                    <Row gutter={[8, 8]}>
                        {screenshots.map((s) => (
                            <Col key={s.id} xs={24} sm={12} md={8} lg={6} xl={4}>
                                <Card
                                    hoverable
                                    style={{ width: "100%" }}
                                    bodyStyle={{ padding: "6px", textAlign: "center" }}
                                    cover={
                                        <div
                                            style={{
                                                width: "100%",
                                                aspectRatio: "1 / 1",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#fafafa",
                                            }}
                                        >
                                            <Image
                                                alt="screenshot"
                                                src={s.thumbnailUrl}
                                                preview={{ src: s.imageUrl }}
                                                style={{
                                                    objectFit: "cover",
                                                    width: "100%",
                                                    height: "100%",
                                                }}
                                            />
                                        </div>
                                    }
                                >
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        Created: {new Date(s.createdOn).toLocaleString()}
                                    </Text>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            ) : (
                <Empty description="No screenshots available" />
            )}
        </Card>
    );
};

export default DeviceScreenshotsCard;